module.exports = __webpack_public_path__ + "static/media/25.375a4ee.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/25.wav
// module id = v/fB
// module chunks = 0